<template>
  <div class="input">
    <el-form-item :label="label" :prop="name" >
      <el-select placeholder="请选择/Select" @input="onInput(name, $event)" v-model="value" :multiple="multiple" clearable>
        <el-option v-for="option in options" :key="option.id" :value= "option.id" :label="option.name"/>
      </el-select>
    </el-form-item>
  </div>
</template>
<style scoped>
  .input >>> .el-input {
    width: 150px;
  }
  .input {
    display: inline;
  }
</style>
<script>
  export default {
    props: {
      label: String,
      name: String,
      options: Array,
      defVal: Number|String,
      multiple: Boolean,
      activeIndex: String
    },
    data: function () {
        return {
            value:this.defVal
        }
    },
    watch: {
       activeIndex: function () {
          this.value = null
       }
    },
    mounted: function () {
      this.init();
    },
    methods: {
      init: function () {
          if(this.defVal !=="" && !_.isNil(this.defVal)) {
              this.onInput(this.name,this.defVal)
          }
      },
      onInput: function (name,val) {
        this.$emit('input', {[name]:val});
      }
    }
  }
</script>
